import Vue from "vue";

type Cleanup = () => void;

interface VmWithCleanups {
  _cleanups?: Cleanup[];
}

function pushCleanup(vm: VmWithCleanups, fn: Cleanup): void {
  if (!vm._cleanups) {
    vm._cleanups = [];
  }
  vm._cleanups.push(fn);
}

export function bindListener<K extends keyof WindowEventMap>(
  vm: Vue,
  target: Window,
  event: K,
  handler: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions
): void;
export function bindListener<K extends keyof DocumentEventMap>(
  vm: Vue,
  target: Document,
  event: K,
  handler: (this: Document, ev: DocumentEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions
): void;
export function bindListener(
  vm: Vue,
  target: EventTarget,
  event: string,
  handler: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions
): void;
export function bindListener(
  vm: Vue,
  target: EventTarget,
  event: string,
  handler: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions
): void {
  target.addEventListener(event, handler, options);
  pushCleanup(vm as VmWithCleanups, () =>
    target.removeEventListener(event, handler, options)
  );
}

export function bindInterval(vm: Vue, fn: () => void, ms: number): number {
  const id = window.setInterval(fn, ms);
  pushCleanup(vm as VmWithCleanups, () => window.clearInterval(id));
  return id;
}

export const listenerCleanupMixin = Vue.extend({
  beforeDestroy(this: Vue & VmWithCleanups) {
    if (!this._cleanups) return;
    for (const fn of this._cleanups) {
      try {
        fn();
      } catch {
        // ignore — cleanups should be idempotent
      }
    }
    this._cleanups = [];
  }
});
